import { handlerApiError } from '../../../lib/basicRepository';
import { restApi } from '../../../services/api';
import { GetProductColorsSharingMaterialOutput } from '../interfaces/orderMaterial.types';

const PATH = 'orders';

const orderMaterialRepository = (orderId: string) => {
  const getProductColorsSharingMaterial = async (productColorIds: string[]) =>
    handlerApiError<GetProductColorsSharingMaterialOutput>(
      await restApi.post(`${PATH}/${orderId}/related-materials`, { productColorIds }),
    );

  return { getProductColorsSharingMaterial };
};

export default orderMaterialRepository;
